export default __webpack_public_path__ + "static/media/pos-pro-14.5208b1be.jpg";